
export const hollyMediaArray = [
  {
    _id: 'hollyMediaId1',
    userId: 'hollyUserId',
    email: 'holly@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-1-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-1-p.png`,
    description: ``,
    captions: [
      `#MondaysAmIRight?`,
      `Woke up like this`,
      `My best blue steel`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hollyMediaId2',
    userId: 'hollyUserId',
    email: 'holly@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-2-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-2-p.png`,
    description: ``,
    captions: [
      `How history will remember me`,
      `It's all about the simple things`,
      `Don't show this to my mom`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hollyMediaId3',
    userId: 'hollyUserId',
    email: 'holly@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-3-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-3-p.png`,
    description: ``,
    captions: [
      `It's all about the simple things`,
      `My quarter life crisis looks like`,
      `You had to be there`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hollyMediaId4',
    userId: 'hollyUserId',
    email: 'holly@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-4-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-4-p.png`,
    description: ``,
    captions: [
      `My quarter life crisis looks like`,
      `It's all about the simple things`,
      `You had to be there`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hollyMediaId5',
    userId: 'hollyUserId',
    email: 'holly@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-5-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-5-p.png`,
    description: ``,
    captions: [
      `The moment I knew my modeling career was over`,
      `Don't judge me`,
      `Dating me will look like`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hollyMediaId6',
    userId: 'hollyUserId',
    email: 'holly@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-6-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-6-p.png`,
    description: ``,
    captions: [
      `Don't judge me`,
      `Pre-coffee me`,
      `Caught in the act`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hollyMediaId7',
    userId: 'hollyUserId',
    email: 'holly@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-7-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-7-p.png`,
    description: ``,
    captions: [
      `Pre-coffee me`,
      `My uniform`,
      `Dating me will look like`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hollyMediaId8',
    userId: 'hollyUserId',
    email: 'holly@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-8-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-8-p.png`,
    description: ``,
    captions: [
      `My uniform`,
      `Lowkey flex`,
      `Me during Fashion Week`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hollyMediaId9',
    userId: 'hollyUserId',
    email: 'holly@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-9-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-9-p.png`,
    description: ``,
    captions: [
      `My quarter life crisis looks like`,
      `It's all about the simple things`,
      `You had to be there`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hollyMediaId10',
    userId: 'hollyUserId',
    email: 'holly@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-10-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-10-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `#MondaysAmIRight?`,
      `My best blue steel`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hollyMediaId11',
    userId: 'hollyUserId',
    email: 'holly@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-11-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-11-p.png`,
    description: ``,
    captions: [
      `#MondaysAmIRight?`,
      `Woke up like this`,
      `My best blue steel`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hollyMediaId12',
    userId: 'hollyUserId',
    email: 'holly@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-12-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-12-p.png`,
    description: ``,
    captions: [
      `How history will remember me`,
      `My life peaked when`,
      `Me during Fashion Week`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hollyMediaId13',
    userId: 'hollyUserId',
    email: 'holly@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-13-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-13-p.png`,
    description: ``,
    captions: [
      `Me in my blogging days`,
      `How my friends see me`,
      `Me during Fashion Week`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'hollyMediaId14',
    userId: 'hollyUserId',
    email: 'holly@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-14-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-14-p.png`,
    description: ``,
    captions: [
      `Me in my blogging days`,
      `How my friends see me`,
      `Me during Fashion Week`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  }
]